import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../../MdmCardFormStore";
import { FormField } from "../../types/MdmCardFormTypes";
import * as styles from "./FieldBox.module.less";

interface PropsFieldBox {
  children?: React.ReactNode;
  field: FormField;
  form: MdmCardFormStore;
}

export const FieldBox: React.FC<PropsFieldBox> = observer((props) => {
  const { children, field, form } = props;
  const errItem = form.errors[field.path];
  const visible = form.visibleKeys.has(field.key);
  return (
    <div className={styles.fieldBox}>
      <div className={styles.titleBox}>
        {form.isRequiredField(field.path) && (
          <span className={styles.requiredMark}>*</span>
        )}
        <span className={styles.titleText}>
          {form.evaluateText(field.meta.title)}
        </span>
        {!visible && <b>Hidden</b>}
      </div>
      <div className={styles.item}>{children}</div>
      {errItem && <div className={styles.error}>{errItem.message}</div>}
    </div>
  );
});
